import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import InputMask from "react-input-mask";
import "./css/financeiro.css";

import UI from "../../actions/ui-helper";
import API from "../../actions/api-helper";
import StringUtil from "../../actions/string";
import DataUtil from "../../actions/data.js";
import { objectGetAllArrayStripedValues } from "../main/utils/object";
import { formatMoneyToRequest } from "../main/utils/utils";
import Currency from "../main/utils/masks/Currency";
import Util from "../../actions/util.js";

import ConsultaCategoriaResultado from "./ConsultaCategoriaResultado";

class ConsultaCategoria extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consulta: {
        cadastroDe: "01/01/2000",
        cadastroAte: DataUtil.hoje(),
      },
      resultado: [],
      categorias: [],
      formaPagamentos: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeValor = this.handleChangeValor.bind(this);
    this.consulta = this.consulta.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();

    this.consulta();
  }

  componentDidMount() {
    this.initialize();
  }

  initialize = async () => {
    this.fetchCategoria();
    this.fetchFormaPagamento();
  };

  fetchCategoria = async () => {
    UI.loader("show", "Um momento...");
    await API.get("/categoria")
      .then((categorias) => {
        this.setState({ categorias });
        UI.loader("hide");
      })
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  };

  fetchFormaPagamento = async () => {
    UI.loader("show", "Um momento...");
    await API.get("/forma-pagamento")
      .then((formaPagamentos) => {
        this.setState({ formaPagamentos });
        UI.loader("hide");
      })
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  };

  handleChange(event) {
    let consulta = this.state.consulta;
    let name = event.target.name;
    consulta[name] = event.target.value;

    (consulta[name].length === 0 || consulta[name] === "TODAS") &&
      delete consulta[name];
    this.setState({ consulta });
  }

  handleChangeValor(event) {
    let consulta = this.state.consulta;
    let name = event.target.name;
    consulta[name] = event.target.value;

    consulta[name] = formatMoneyToRequest(consulta[name]);

    consulta[name] === null && delete consulta[name];

    this.setState({ consulta });
  }

  handleExcluir = async (lancamentoId) => {
    UI.alert(true, "Lancamento excluido com sucesso!");
    try {
      UI.loader("show", "Um momento...");
      await API.post("/financeiro/inativar/" + lancamentoId);
      UI.loader("hide");
    } catch {
      UI.loader("hide");
    } finally {
      this.consulta();
    }
  };

  consulta = () => {
    let filtros = this.state.consulta;
    const params = objectGetAllArrayStripedValues({
      ...filtros,
    });

    UI.loader("show", "Um momento...");
    API.get("/financeiro/consulta?" + StringUtil.serialize(params))
      .then((json) => {
        this.setState({ resultado: json });
        UI.loader("hide");
      })
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  };

  exportarCSV = async () => {
    if (!Util.exportarLancamentoCSV(this.state.resultado)) {
      UI.alert(false, "Não há nenhum resultado para ser exportado.");
    }
  };

  renderOption = (option) => {
    return Array.isArray(option) && option.length
      ? option.map((op, i) => {
          if (i === 0) {
            return (
              <>
                <option value="TODAS">TODAS</option>
                <option value={op.id}>{op.descricao}</option>
              </>
            );
          } else {
            return <option value={op.id}>{op.descricao}</option>;
          }
        })
      : [];
  };

  render() {
    const { formaPagamentos, categorias } = this.state;

    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <h4 className="card-title">CONSULTA FINANCEIRO</h4>
                  </div>
                  <div className="col-md-6 text-right">
                    <button
                      onClick={() => {
                        this.props.history.push("/financeiro/cadastro");
                      }}
                      className="btn btn-rounded btn-icons btn-outline-success"
                      type="button"
                    >
                      <i className="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
                <p className="card-description" />{" "}
                <div className="form-group row">
                  <div className="col-sm-3">
                    <label>Origem</label>
                    <select
                      name="origem"
                      className="form-control"
                      value={this.state.consulta.origem}
                      onChange={this.handleChange}
                    >
                      <option value="TODAS">TODAS</option>
                      <option value="RECEITAS">ENTRADA</option>
                      <option value="RECEITA">RECEITA</option>
                      <option value="DESPESAS">DESPESAS</option>
                      <option value="TRANSFERENCIA">TRANSFERÊNCIA</option>
                    </select>
                  </div>
                  <input type="hidden" name="id" value="0" />
                  <div className="col-sm-3">
                    <label>Descrição</label>
                    <input
                      autoFocus
                      placeholder="DESCRIÇÃO"
                      name="descricao"
                      type="text"
                      maxLength="254"
                      className="form-control"
                      value={this.state.consulta.descricao}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label>Documento Nota Fiscal</label>
                    <input
                      autoFocus
                      placeholder="NOTA FISCAL"
                      name="notaFiscal"
                      type="text"
                      maxLength="254"
                      className="form-control"
                      value={this.state.consulta.notaFiscal}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label>Forma de Pagamento</label>
                    <select
                      name="formaPagamentoId"
                      className="form-control"
                      value={this.state.consulta.formaPagamentoId}
                      onChange={this.handleChange}
                    >
                      {this.renderOption(formaPagamentos)}
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-sm-3">
                    <label>Valor</label>
                    <input
                      autoFocus
                      placeholder="VALOR"
                      name="valor"
                      type="text"
                      maxLength="11"
                      className="form-control"
                      value={Currency.conformToMask(this.state.consulta.valor)}
                      onChange={this.handleChangeValor}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label>Categoria</label>
                    <select
                      name="categoriaId"
                      className="form-control"
                      value={this.state.consulta.categoriaId}
                      onChange={this.handleChange}
                    >
                      {this.renderOption(categorias)}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label>Situação</label>
                    <select
                      name="situacao"
                      className="form-control"
                      value={this.state.consulta.situacao}
                      onChange={this.handleChange}
                    >
                      <option value="TODAS">TODAS</option>
                      <option value="VENCIDO">VENCIDO</option>
                      <option value="AVENCER">À VENCER</option>
                      <option value="VENCENDONODIA">VENCENDO NO DIA</option>
                      <option value="PAGO">PAGO</option>
                    </select>
                  </div>
                  <div className="col-sm-3">
                    <label>Periodicidade</label>
                    <select
                      name="periodicidade"
                      className="form-control"
                      value={this.state.consulta.periodicidade}
                      onChange={this.handleChange}
                    >
                      <option value="TODAS">TODAS</option>
                      <option value="AVISTA">À VISTA</option>
                      <option value="PARCELADO">PARCELADO</option>
                      <option value="RECORRENTE">RECORRENTE</option>
                      <option value="SEMANAL">SEMANAL</option>
                      <option value="QUINZENAL">QUINZENAL</option>
                      <option value="BIMESTRAL">BIMESTRAL</option>
                      <option value="TRIMESTRAL">TRIMESTRAL</option>
                      <option value="SEMESTRAL">SEMESTRAL</option>
                      <option value="ANUAL">ANUAL</option>
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>Cadastrado Desde</label>
                    <InputMask
                      placeholder="CADASTRADO DE"
                      name="cadastroDe"
                      className="form-control"
                      mask="99/99/9999"
                      value={this.state.consulta.cadastroDe}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Cadastrado Até</label>
                    <InputMask
                      placeholder="CADASTRADO ATÉ"
                      name="cadastroAte"
                      className="form-control"
                      mask="99/99/9999"
                      value={this.state.consulta.cadastroAte}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label>Tipo</label>
                    <select
                      name="tipo"
                      className="form-control"
                      value={this.state.consulta.tipo}
                      onChange={this.handleChange}
                    >
                      <option value="TODAS">TODAS</option>
                      <option value="FIXA">FIXA</option>
                      <option value="VARIAVEL">VARIÁVEL</option>
                      <option value="PESSOAS">PESSOAS</option>
                      <option value="IMPOSTOS">IMPOSTOS</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label>Pago</label>
                    <select
                      name="pago"
                      className="form-control"
                      value={this.state.consulta.pago}
                      onChange={this.handleChange}
                    >
                      <option value="TODAS">TODAS</option>
                      <option value="S">SIM</option>
                      <option value="N">NÃO</option>
                    </select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 text-right">
                    <button
                      type="button"
                      className="btn btn-sm btn-success mb-2"
                      onClick={() => this.exportarCSV()}
                    >
                      <i className="fa fa-download"></i>&nbsp; Exportar CSV
                    </button>
                    &nbsp;
                    <button
                      type="submit"
                      className="btn btn-sm btn-primary mb-2"
                    >
                      <i className="fa fa-search"></i>&nbsp; Pesquisar
                    </button>
                  </div>
                </div>
                &nbsp;
                <ConsultaCategoriaResultado
                  onExcluir={this.handleExcluir}
                  resultado={this.state.resultado}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default withRouter(ConsultaCategoria);
